import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('integrations')

export const integration = {
	computed : {
		...mapState([
			'activeCard',
			'addingIntegration',
			'editingIntegration',
		]),
		/**
		 * Is Active
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Is the provider active?
		 */
		isActive () {
			if (this.provider.slug !== this.activeCard) {
				return false
			}

			if (this.showIntegrations && !this.hasIntegrations) {
				return false
			}

			return true
		},
		/**
		 * Has Integrations
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Does this provider have integrations?
		 */
		hasIntegrations () {
			return 0 < this.provider.integrations.length
		},
		/**
		 * Show Form
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Should this provider's form be shown?
		 */
		showForm () {
			return this.addingIntegration || this.editingIntegration
		},
		/**
		 * Show Integrations
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Should this provider's integrations be shown?
		 */
		showIntegrations () {
			return !this.showForm && this.hasIntegrations
		},
		/**
		 * User Has Access to Integration
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Do they have accesss?
		 */
		userHasAccessToIntegration () {
			if (this.provider.isFake) {
				return false
			}

			const slug = this.provider.slug.replace(/-(featured|existing)/, '')

			return this.$store.getters.hasIntegration(slug)
		},
		/**
		 * Is OM Analytics
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Is this provider OM Analytics?
		 */
		 isOmAnalytics () {
			return 'omanalytics' === this.provider.slug
		},
		/**
		 * Is Google Analytics
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Is this provider Google Analytics?
		 */
		 isGoogleAnalytics () {
			return 'googleanalytics' === this.provider.slug
		},
		/**
		 * Force Configurable
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Should we force a configurable state?
		 */
		forceConfigurable () {
			return this.isOmAnalytics || this.isGoogleAnalytics
		},
		/**
		 * Is Featured
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Is this provider featured?
		 */
		isFeatured () {
			return 'undefined' !== typeof this.provider.featured && true === this.provider.featured
		},
		/**
		 * Can create new.
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		canCreate () {
			return 'monsterleads-existing' !== this.provider.slug && !this.provider.legacy
		},
		/**
		 * Is Filtering
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Are providers currently being filtered?
		 */
		isFiltering () {
			return 0 !== this.filters.length
		},
		/**
		 * Is Searching
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Are providers currently being searched?
		 */
		isSearching () {
			return '' !== this.search
		},
	},
	methods : {
		...mapActions([
			'configureProvider',
			'connectProvider',
			'resetProviders',
		]),
		...mapMutations([
			'setActiveContentError',
		]),
		/**
		 * Handle Close
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleClose () {
			this.resetProviders()
		},
		/**
		 * Handle Configure
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleConfigure () {
			// OM Analytics only shows an education modal.
			if (this.isOmAnalytics) {
				this.$modal.show('om-analytics')
				return
			}

			// Google Analytics routes to the settings page.
			if (this.isGoogleAnalytics) {
				// Wait for transition to complete.
				this.$bus.$once('routerComponentMounted', () => {
					this.$bus.$emit('scrollToRef', 'ga')
				})
				this.$router.push({ name: 'settings-tab', params: { selectedTab: 'site' } })
				return
			}

			// MonsterLeads doesn't show the warning.
			if ('monsterleads' !== this.provider.slug) {
				this.setActiveContentError(`
					<strong>Updating this provider could affect any connected campaigns.</strong> 
					If you have connected campaigns, please check that all lists and options are 
					still set properly for those campaigns.
				`)
			}

			this.configureProvider(this.provider.slug)
		},
		/**
		 * Handle Connect
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleConnect () {
			if (this.provider.isFake) {
				this.$modal.show('custom-integrations')
				return
			}

			if (!this.userHasAccessToIntegration) {
				this.$modal.show(`${this.provider.slug}-no-access-integration`)
				return
			}

			this.connectProvider(this.provider.slug)
		},
	},
}
